import dynamic from "next/dynamic";
import ReviewCardsReviewsConfig from "./review-cards-reviews-config";
import ReviewCardsReviewsAdvancedConfig from "./review-cards-reviews-advanced-config";
const ReviewCardsReviewsComponent = dynamic(()=>import("./review-cards-reviews-component"));
export default {
    ReviewCardsReviewsComponent,
    ReviewCardsReviewsConfig,
    ReviewCardsReviewsAdvancedConfig
};
